import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ROLE } from 'src/app/core/enums';
import { MethodsService } from '../utils/methods.service';

/**
 * Guard que actúa como redirector inteligente según el rol del usuario.
 * Se aplica a la ruta raíz para evitar que el componente de Analytics
 * se cargue momentáneamente antes de redirigir (efecto "flash").
 * Siempre devuelve un UrlTree, nunca renderiza UI propia.
 */
@Injectable({
	providedIn: 'root'
})
export class HomeRedirectGuard {
	private _router = inject(Router);
	private _methodsService = inject(MethodsService);

	canActivate(): UrlTree {
		// Superadmin: plantillas de correo
		if (this._methodsService.isSuperAdmin()) {
			return this._router.createUrlTree(['/superadmin/email-templates']);
		}

		// Admin: Resumen General de Trazas
		if (this._methodsService.checkRoleUser(ROLE.ADMINISTRATOR)) {
			return this._router.createUrlTree(['/traces/dashboard']);
		}

		return this._router.createUrlTree(['/dashboard']);
	}
}
